import {fromOffersCalculateResponse} from './mappers/from-offers-calculate-response'
import {toOffersCalculateRequest} from './mappers/to-offers-calculate-request'
import {toOffersInfoBody} from './mappers/to-offers-info-body'
import type {CreateOfferService} from './types'

const DEFAULT_LAST_MILE_POLICY = {last_mile_policy: ''}

export const createOfferService: CreateOfferService = dcaaRepository => {
  const {fetchOffersCalculate, fetchOffersInfo} = dcaaRepository

  return {
    fetchOffers(payload, selectedVertical, country) {
      const queryParams: Record<string, string> = {}

      if (country) {
        queryParams['country'] = country
      }

      if (payload.preOrderId) {
        queryParams['pre_order_id'] = payload.preOrderId
      }

      return fetchOffersCalculate(toOffersCalculateRequest(payload), queryParams)
        .then(fromOffersCalculateResponse)
        .then(response => {
          return response.filter(result => result.vertical === selectedVertical)
        })
    },
    fetchTimeIntervals(query) {
      return fetchOffersInfo(toOffersInfoBody(query), DEFAULT_LAST_MILE_POLICY).then(result => ({
        offers: result?.offers ?? [],
        policy: DEFAULT_LAST_MILE_POLICY,
      }))
    },
  }
}

export type {FetchTimeIntervals, FetchTimeIntervalsQuery, GetOffersPayload} from './types'
